/* ============================================
   BROCKLAN SPORTS — Theme JS v3
   Quick-view modal, add-to-cart, wishlist, search
   ============================================ */

// ── Quick-View Modal ──────────────────────────
function bQuickView(url, title, price, variantId, desc, isNew) {
  var overlay = document.getElementById('product-modal-overlay');
  var panel = document.getElementById('pmodal-img-panel');

  // Status
  var dot = document.getElementById('pmodal-dot');
  var statusText = document.getElementById('pmodal-status-text');
  if (isNew) { dot.style.background = '#4CAF50'; statusText.textContent = 'New Arrival'; }
  else { dot.style.background = '#C9A84C'; statusText.textContent = 'In Collection'; }

  // Content
  document.getElementById('pmodal-title').textContent = title;
  document.getElementById('pmodal-price').textContent = price;
  document.getElementById('pmodal-desc').textContent = desc;
  document.getElementById('pmodal-view').href = url;

  // ATC
  var atc = document.getElementById('pmodal-atc');
  atc.href = '#';
  atc.onclick = function(e) {
    e.preventDefault();
    bAddToCart(variantId, atc);
  };

  // Sizes
  var sizesEl = document.getElementById('pmodal-sizes');
  sizesEl.innerHTML = '';
  ['XS','S','M','L','XL','XXL'].forEach(function(s, i) {
    var btn = document.createElement('button');
    btn.className = 'pmodal__size' + (i === 0 ? ' active' : '');
    btn.textContent = s;
    btn.onclick = function() {
      sizesEl.querySelectorAll('.pmodal__size').forEach(function(b){b.classList.remove('active');});
      btn.classList.add('active');
    };
    sizesEl.appendChild(btn);
  });

  // Spotlight effect on image panel
  panel.onmousemove = function(e) {
    var r = panel.getBoundingClientRect();
    var x = ((e.clientX - r.left) / r.width) * 100;
    var y = ((e.clientY - r.top) / r.height) * 100;
    var spot = document.getElementById('pmodal-spotlight');
    spot.style.background = 'radial-gradient(circle 180px at ' + x + '% ' + y + '%, rgba(201,168,76,0.18) 0%, transparent 70%)';
    spot.style.opacity = '1';
  };
  panel.onmouseleave = function() { document.getElementById('pmodal-spotlight').style.opacity = '0'; };

  overlay.classList.add('open');
  document.body.style.overflow = 'hidden';
}

function openStaticModal(name, price, category) {
  bQuickView('#', name, price, null, category + ' — ' + name, false);
}

function closeProductModal() {
  document.getElementById('product-modal-overlay').classList.remove('open');
  document.body.style.overflow = '';
}

// Close on Escape
document.addEventListener('keydown', function(e) { if (e.key === 'Escape') closeProductModal(); });

// ── Add to Cart ───────────────────────────────
function bAddToCart(variantId, btn) {
  if (!variantId) return;
  var orig = btn.innerHTML;
  btn.innerHTML = 'Adding…';
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
    body: JSON.stringify({id: variantId, quantity: 1})
  })
  .then(function(r){return r.json();})
  .then(function(){
    btn.innerHTML = '✓ Added to Bag';
    bUpdateCartCount();
    setTimeout(function(){ btn.innerHTML = orig; }, 2000);
  })
  .catch(function(){ btn.innerHTML = orig; });
}

function bQuickAdd(variantId, btn) {
  var orig = btn.innerHTML;
  btn.innerHTML = 'Adding…';
  btn.disabled = true;
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
    body: JSON.stringify({id: variantId, quantity: 1})
  })
  .then(function(r){return r.json();})
  .then(function(){
    btn.innerHTML = '✓ Added';
    bUpdateCartCount();
    setTimeout(function(){ btn.innerHTML = orig; btn.disabled = false; }, 1800);
  })
  .catch(function(){ btn.innerHTML = orig; btn.disabled = false; });
}

// ── Cart Count ────────────────────────────────
function bUpdateCartCount() {
  fetch('/cart.js').then(function(r){return r.json();}).then(function(cart){
    var el = document.querySelector('.bn__cart-count');
    if (cart.item_count > 0) {
      if (!el) {
        var wrap = document.querySelector('.bn__cart-wrap');
        if (wrap) {
          var span = document.createElement('span');
          span.className = 'bn__cart-count';
          span.textContent = cart.item_count;
          wrap.appendChild(span);
        }
      } else { el.textContent = cart.item_count; }
    } else if (el) { el.remove(); }
  });
}

// ── Wishlist ──────────────────────────────────
function bWishToggle(btn, id) {
  var k = 'bwish_' + id;
  var active = localStorage.getItem(k);
  var svg = btn.querySelector('svg');
  if (active) {
    localStorage.removeItem(k);
    btn.classList.remove('active');
    if (svg) svg.setAttribute('fill', 'none');
  } else {
    localStorage.setItem(k, '1');
    btn.classList.add('active');
    if (svg) svg.setAttribute('fill', 'currentColor');
  }
}

// Restore wishlist states on load
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.bpcard__wish').forEach(function(btn) {
    var m = btn.getAttribute('onclick') && btn.getAttribute('onclick').match(/'([^']+)'\)/);
    if (m && localStorage.getItem('bwish_' + m[1])) {
      btn.classList.add('active');
      var svg = btn.querySelector('svg');
      if (svg) svg.setAttribute('fill', 'currentColor');
    }
  });
});
